// @flow
import { createSelector } from "reselect"

import createAncillaryReducer from "../reducer"
import { serviceApplicableSelector, servicePriceSelector, serviceAddedSelector } from "../selectors"
import Price from "common/records/Price"
import type PriceType from "common/records/Price"
import { getActiveStep } from "booking/services/states/reducer"
import { getJourney } from "../../../journey/reducer"
import { passengersCountWithoutInfantsSelector } from "../../../reservation/selectors/passengersSelectors"

export type AdditionalServiceState = {
  name: string,
  service: string,
  type: number,
  data: {
    is_applicable: boolean,
    price: PriceType,
  },
}

const paidCheckinReducer = createAncillaryReducer("paidCheckin")

export const isPaidCheckinEnabled: $FlowFixMe = createSelector(
  state => state.splitster,
  splitster => ["fakeDoor"].includes(splitster.get("PAID_CHECK_IN").value),
)

export const isPaidCheckinEvaluationEnabled: $FlowFixMe = createSelector(
  state => state.splitster,
  splitster => splitster.get("PAID_CHECK_IN").value === "fakeDoor",
)

export const getPaidCheckinCount: $FlowFixMe = createSelector(
  getJourney,
  passengersCountWithoutInfantsSelector,
  (journey, passengersCount) => journey.getFlightsCount() * passengersCount,
)

export const getOriginalPaidCheckinPrice: $FlowFixMe = createSelector(
  servicePriceSelector("paidCheckin"),
  getPaidCheckinCount,
  (rawPrice, paidCheckinCount) =>
    rawPrice ? Price.multiply(rawPrice, paidCheckinCount) : rawPrice,
)

export const getPaidCheckinPrice: $FlowFixMe = createSelector(
  getOriginalPaidCheckinPrice,
  isPaidCheckinEvaluationEnabled,
  getActiveStep,
  (originalPrice, paidCheckinEvaluationEnabled, activeStep) => {
    if (!paidCheckinEvaluationEnabled || activeStep !== 2) {
      return originalPrice
    }

    return new Price({ amount: 0 })
  },
)

export const getPaidCheckinOrderedPrice: $FlowFixMe = createSelector(
  getPaidCheckinPrice,
  serviceAddedSelector("paidCheckin"),
  isPaidCheckinEvaluationEnabled,
  (price, isAdded, paidCheckinEvaluationEnabled) =>
    isAdded && paidCheckinEvaluationEnabled ? price : new Price({ amount: 0 }),
)

export const isPaidCheckinApplicableSelector: $FlowFixMe = serviceApplicableSelector("paidCheckin")

export const paidCheckInAddedSelector: $FlowFixMe = serviceAddedSelector("paidCheckin")

export const shouldRenderPaidCheckinInBill: $FlowFixMe = createSelector(
  serviceApplicableSelector("paidCheckin"),
  isPaidCheckinEvaluationEnabled,
  serviceAddedSelector("paidCheckin"),
  getActiveStep,
  (isApplicable, paidCheckinEvaluationEnabled, added, activeStep) =>
    isApplicable && paidCheckinEvaluationEnabled && (added || activeStep === 2),
)

export const shouldRenderFreeCheckinBannerSelector: $FlowFixMe = createSelector(
  state => state.splitster,
  serviceApplicableSelector("paidCheckin"),
  (splitster, isPaidCheckinApplicable) =>
    splitster.get("FREE_CHECKIN_BANNER").value === "show" && isPaidCheckinApplicable,
)

export default paidCheckinReducer
